import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'

const tubeHeight = em(360)
const tubeHeightMd = em(520)

export const TubeWrapper = styled.div`
  position: relative;
  height: ${tubeHeight};

  ${p => p.theme.mq.upMd} {
    height: ${tubeHeightMd};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  position: absolute;
  left: 0;
  top: 0;
  width: ${em(300)};
  max-width: 100%;

  ${p => p.theme.mq.upMd} {
    top: auto;
    bottom: -20%;
    left: 50%;
    width: 100%;
    max-width: ${em(400)};
    height: auto;
    transform: translateX(-50%);
  }

  ${p => p.theme.mq.upLg} {
    top: -20%;
    bottom: auto;
  }
`
